import { ReactElement } from "react";
import { SpinnerLegacy } from "../../../../../components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../../components/modal/Dialog";
import { useSupplier } from "../../../../../hooks/api/v2/supplier/useSupplier";

export const StorefrontPaymentNotesDialog = ({
  active,
  onDismiss,
  supplierId,
}: {
  active: boolean;
  onDismiss: () => void;
  supplierId: number;
}): ReactElement => {
  const supplierQuery = useSupplier(supplierId);
  return (
    <Dialog active={active} onDismiss={onDismiss} fullHeight={true}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        className={"z-10 pb-0"}
        title={`${supplierQuery.data?.Business.name}'s payment notes`}
      />
      <DialogContent>
        {supplierQuery.isLoading ? (
          <SpinnerLegacy />
        ) : (
          <div className="rounded-lg border border-solid p-4">
            <p>{supplierQuery.data?.paymentNotes}</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
